








































































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { PlanningPrevisionnel } from "@/api/models/planningsPrevisionnels/planningPrevisionnel";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BBadge,
  BSpinner
} from "bootstrap-vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { Entreprise } from "@/api/models/adherents/adherent";
import UpdatePlanningPrevisionnel from "./UpdatePlanningPrevisionnel.vue";
import CreatePlanningPrevisionnel from "./CreatePlanningPrevisionnel.vue";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    BBadge,
    BSpinner,
    CreatePlanningPrevisionnel,
    UpdatePlanningPrevisionnel, 
  },
})
export default class ListPlanningsPrevisionnels extends Vue {
  @Prop({ required: true }) adherent!: Entreprise;
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  isAddNewPlanningPrevisionnelSidebarActive = false;
  isUpdatePlanningPrevisionnelSidebarActive = false;
  selectedPlanningPrevisionnelId = "";
  isSortDirDesc = false;
  sortBy = "nomFichier";

  tableColumns = [
    {key: 'nomFichier', sortable: true}, 
    {key: 'description', sortable: true}, 
    {key: 'dateDerniereModification', sortable: true}, 
    'actions'
  ];
  paginatedListPlanningsPrevisionnels = new PaginatedList<PlanningPrevisionnel>();
  loading = true;

  async created() {
    await this.loadListPlanningsPrevisionnels({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListPlanningsPrevisionnels.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListPlanningsPrevisionnels.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  async paginationChanged() {
    await this.loadListPlanningsPrevisionnels({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
    });
  }

  selectPlanningPrevisionnel(planningPrevisionnelId: string) {
    this.selectedPlanningPrevisionnelId = planningPrevisionnelId;
    this.isUpdatePlanningPrevisionnelSidebarActive = true;
  }

  async downloadFile(adherentId: string, planningPrevisionnelId: string) {
    await this.$http.myressif.entreprises
      .downloadPlanningPrevisionnel(adherentId, planningPrevisionnelId)
      .then(
        async (response: any) => {
          window.open(response);
        },
        (error: any) => {
          if (error?.response?.data?.errors) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error.message,
            });
          }
        }
      );
  }

  async loadListPlanningsPrevisionnels(params: any) {
    if (!params || params?.reset) {
      this.paginatedListPlanningsPrevisionnels = new PaginatedList<PlanningPrevisionnel>();
    }
    this.loading = true;
    await this.$http.myressif.entreprises
      .getListPlanningsPrevisionnelsByEntrepriseId(
        this.$route.params.id,
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? ""
      )
      .then((response: PaginatedList<PlanningPrevisionnel>) => {
        this.paginatedListPlanningsPrevisionnels = response;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;

    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc
    };
    this.isSortDirDesc = !this.isSortDirDesc;
    this.loadListPlanningsPrevisionnels(params);
  }

  askDelete(id: string) {
    this.$bvModal
      .msgBoxConfirm("Etes-vous sûr de vouloir supprimer ce planning prévisionnel ?", {
        title: "Confirmation de suppression",
        size: "sm",
        okVariant: "primary",
        okTitle: "Oui",
        cancelTitle: "Non",
        cancelVariant: "outline-secondary",
        hideHeaderClose: false,
        centered: true,
      })
      .then(async (value) => {
        if (value === true) {
          await this.confirmDelete(id);
        } else {
          return;
        }
      });
  }

  async confirmDelete(id: string) {
    await this.$http.myressif.entreprises
      .deletePlanningPrevisionnel(this.$route.params.id, id)
      .then(
        async (response: string) => {
          successAlert.fire({
            title: "Suppression d'un planning prévisionnel",
            text: "Suppression effectuée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.paginationChanged();
      });
  }
}
